// / /防止连续点击
export default {
    install(Vue){
        Vue.directive('throttle',{
            inserted:function(el,binding){
                let fn = binding.value;
                let timeB,flag;
                el.addEventListener('click',() =>{
                    if(timeB){
                    clearTimeout(flag);
                    return flag = setTimeout(() => fn(),3000)
                    }
                    fn();
                    timeB = setTimeout(() => timeB = null,3000)
                })
            }
        })
    }
}
